import $ from "jquery"
import NumbersFormatter from "app/numbers/formatter/index"

interface Selector {
  main: string,
  loan_amount: string,
  stamp_duty: string,
  commission: string,
  down_payment: string,
  total_principle: string,
  total_interest: string,
  other_fees: string
}

const default_selector: Selector = {
  main:             ".cell-real-estate-mortgages-calculator",
  loan_amount:      ".cell-real-estate-mortgages-calculator_data--mortgage-breakdown--loan-amount",
  stamp_duty:       ".cell-real-estate-mortgages-calculator_data--mortgage-breakdown--stamp-duty",
  commission:       ".cell-real-estate-mortgages-calculator_data--mortgage-breakdown--commission",
  down_payment:     ".cell-real-estate-mortgages-calculator_data--mortgage-breakdown--down-payment",
  total_principle:  ".cell-real-estate-mortgages-calculator_data--mortgage-breakdown--principle",
  total_interest:   ".cell-real-estate-mortgages-calculator_data--mortgage-breakdown--interest",
  other_fees:       ".cell-real-estate-mortgages-calculator_data--mortgage-breakdown--other-fees",
}

const createTableChart = ({ad_valorem_stamp_duty, down_payment, loan_amount, total_interest, commission, total_cost, legal_fee}: {
  ad_valorem_stamp_duty: number,
  down_payment: number,
  loan_amount: number,
  total_interest: number,
  commission: number,
  total_cost: number | string,
  legal_fee: number
}):void => {
  const $el = $(default_selector.main)

  // pending for moblie website update
  const stamp_duty = ad_valorem_stamp_duty

  $el.find(default_selector.loan_amount).text(NumbersFormatter.numberWithCommasAndCurrency(loan_amount, 0) || "")
  $el.find(default_selector.stamp_duty).text(NumbersFormatter.numberWithCommasAndCurrency(stamp_duty, 0) || "")
  $el.find(default_selector.commission).text(NumbersFormatter.numberWithCommasAndCurrency(commission, 0) || "")
  $el.find(default_selector.down_payment).text(NumbersFormatter.numberWithCommasAndCurrency(down_payment, 0) || "")
  $el.find(default_selector.total_principle).text(total_cost)
  $el.find(default_selector.total_interest).text(NumbersFormatter.numberWithCommasAndCurrency(total_interest, 0) || "")
  $el.find(default_selector.other_fees).text(NumbersFormatter.numberWithCommasAndCurrency(commission + legal_fee, 0) || "")
}

export default {
  create: createTableChart,
}
